import React from 'react';
import { RefreshCw, Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Badge } from '../ui/badge';

const nouvelleBase =
  'inline-flex shrink-0 items-center gap-0.5 rounded-md border-transparent bg-emerald-600 px-1.5 py-0 text-[10px] font-semibold text-primary-foreground shadow hover:bg-emerald-600';

const misAJourBase =
  'inline-flex shrink-0 items-center gap-0.5 rounded-md border-transparent bg-amber-500/90 px-1.5 py-0 text-[10px] font-semibold text-white shadow-none hover:bg-amber-500/90';

/** Badge vert « Nouveau » (ligne thème repliée + carte tutoriel) */
export function HelpNouveauBadge({ className }) {
  return (
    <Badge variant="default" className={cn(nouvelleBase, className)} role="status">
      <Sparkles className="h-2.5 w-2.5 shrink-0" strokeWidth={2} aria-hidden />
      Nouveau
    </Badge>
  );
}

/** Badge ambre « Mis à jour » (carte tutoriel uniquement) */
export function HelpMisAJourBadge({ className }) {
  return (
    <Badge variant="secondary" className={cn(misAJourBase, className)} role="status">
      <RefreshCw className="h-2.5 w-2.5 shrink-0" strokeWidth={2} aria-hidden />
      Mis à jour
    </Badge>
  );
}

/** Parcours complété : texte seul */
export function TutorialCompletedLabel({ className }) {
  return (
    <span
      className={cn(
        'text-sm font-medium text-emerald-500 dark:text-emerald-400',
        className,
      )}
      role="status"
    >
      Parcours terminé
    </span>
  );
}

export function TutorialStatusBadge({ status, className }) {
  if (status === 'a_jour') {
    return <TutorialCompletedLabel className={className} />;
  }
  if (status === 'mis_a_jour') {
    return <HelpMisAJourBadge className={className} />;
  }
  return <HelpNouveauBadge className={className} />;
}
